import script from "./MaterialCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaterialCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./MaterialCalendar.vue?vue&type=style&index=0&id=7577a94a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7577a94a"]])

export default __exports__